// extracted by mini-css-extract-plugin
export default {"fetchingData":"_1xc22O0a5r2DL6IeU5svDa","fadeIn":"_2WjG40-owoOoGXO9nJqDS3"};